/**
 * @param {string} redirectURL
 */
export const getReturnUrl = redirectURL =>
    `?returnUrl=${encodeURIComponent(
        redirectURL
            ? redirectURL
            : window.location.pathname + window.location.hash
    )}`;
